import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Role } from '../enum/role';
import { PATH_CONFIG } from 'src/environments/paths.config';
type ProtectedRoute = {
  label: string;
  path: string;
  allowedRoles: Role[];
  options?: Array<{
    label: string;
    path: string;
    allowedRoles: Role[];
    options?: never[];
  }>;
};
@Injectable({
  providedIn: 'root'
})
export class VariablesService {
  private _currentUserRole: Role = Role.NO_EXISTE;
  public get currentUserRole(): Role {
    return this._currentUserRole;
  }
  public set currentUserRole(value: Role) {
    this._currentUserRole = value;
  }

  private _paths: any = environment.paths;
  public get paths(): any {
    return this._paths;
  }
  public set paths(value: any) {
    this._paths = value;
  }
  constructor(private router:Router) { }

  private _nombreCliente: string = '';
  public get nombreCliente(): string {
    return this._nombreCliente;
  }
  public set nombreCliente(value: string) {
    this._nombreCliente = value;
  }

  private _idCliente: number = 0;
  public get idCliente(): number {
    return this._idCliente;
  }
  public set idCliente(value: number) {
    this._idCliente = value;
  }


  private _idUsuario: number = 0;
  public get idUsuario(): number {
    return this._idUsuario;
  }
  public set idUsuario(value: number) {
    this._idUsuario = value;
  }

  private _usuario: string = '';
  public get usuario(): string {
    return this._usuario;
  }
  public set usuario(value: string) {
    this._usuario = value;
  }

  private _celular: number = 0;
  public get celular(): number {
    return this._celular;
  }
  public set celular(value: number) {
    this._celular = value;
  }

  private _email: string = '';
  public get email(): string {
    return this._email;
  }
  public set email(value: string) {
    this._email = value;
  }

  private _isJumpCube: boolean = false;
  public get isJumpCube(): boolean {
    return this._isJumpCube;
  }
  public set isJumpCube(value: boolean) {
    this._isJumpCube = value;
  }

  private _datacliente:any;
  public get datacliente() {
    return localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client')!) : null;
  }
  public set datacliente(value) {
    this._datacliente = value;
  }

  deserializeJson(){
    if (localStorage.getItem('data')){
      const data = JSON.parse(localStorage.getItem('data')!);
      if (data){                 
         this.nombreCliente = (data.nombre1 ? data.nombre1 : '') + ' ' + (data.apellido1 ? data.apellido1 : '');
         this.idCliente = data.idCliente ? data.idCliente : 0;
         this.idUsuario = data.idUsuario ? data.idUsuario : 0;
         this.usuario = data.nombreCompleto ? data.nombreCompleto : '',
         this.email = data.email ? data.email : '',
         this.celular = data.celular ? data.celular : '',
         this.currentUserRole = data.role ? data.role : Role.NO_EXISTE
      }
      else {
        this.currentUserRole = Role.NO_EXISTE;
      }
    }

    if (environment.jumpCube) {
      this.isJumpCube = environment.jumpCube;
    }
    else {
      this.isJumpCube = false;
    }
  }

  deleteLocalVaribles(){
    localStorage.removeItem('client');
    localStorage.removeItem('data');
    localStorage.removeItem('gran-type');
    localStorage.removeItem('registerClient');
  }
  logout(){    
    this.deleteLocalVaribles();
    if (this.idCliente === 0){
      this.router.navigate(['/']);
    }
    else {
      this.router.navigate(['/client']);
    }
  }

}
